import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "./firebase";

const COLLECTION = "recipientLists";

// =======================================
// CREATE
// =======================================
export async function createRecipientList(uid, { name, recipients }) {
  const docRef = await addDoc(collection(db, COLLECTION), {
    userId: uid,
    name,
    recipients,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return docRef.id;
}

// =======================================
// LOAD USER'S LISTS
// =======================================
export async function getUserRecipientLists(uid) {
  const q = query(
    collection(db, COLLECTION),
    where("userId", "==", uid),
    orderBy("createdAt", "desc")
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
}

// =======================================
// UPDATE
// =======================================
export async function updateRecipientList(id, { name, recipients }) {
  await updateDoc(doc(db, COLLECTION, id), {
    name,
    recipients,
    updatedAt: serverTimestamp(),
  });
}

// =======================================
// DELETE
// =======================================
// Deleting a list does not touch any schedule that references it — a
// schedule stores the list's id, not a copy of its recipients, so a
// deleted list simply stops contributing recipients the next time that
// schedule runs (resolveScheduleRecipients on the backend already skips
// ids that no longer resolve to a document). Nothing else to clean up.
export async function deleteRecipientList(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}
